import buildClient from '@/api/client'
import currentOrderQuery from '@/api/order-current.gql'
import completeCurrentOrderQuery from '@/api/complete-current-order.gql'
import orderAdjustmentQuery from '@/api/order-adjustment.gql'
import cartItemsQuery from '@/api/cart-items.gql'
import getStoreQuery from '@/api/store'
import applyPromotionToCurrentOrderQuery from '@/api/apply-promotion-to-current-order'
import removePromotionFromCurrentOrderQuery from '@/api/remove-promotion-from-current-order'

export function fetchCurrentOrder() {
  return buildClient().query(currentOrderQuery)
}

export function fetchStore() {
  return buildClient().query(getStoreQuery())
}

export function fetchCartItems(ids) {
  return buildClient()
    .query(cartItemsQuery, {
      ids,
    })
    .then(data => data.variants)
}

export function applyPromotionToCurrentOrder(promoCode) {
  return buildClient().query(applyPromotionToCurrentOrderQuery(promoCode))
}
export function removePromotionFromCurrentOrder(promoCode) {
  return buildClient().query(removePromotionFromCurrentOrderQuery(promoCode))
}
export function fetchAdjustmentFromCurrentOrder() {
  return buildClient().query(orderAdjustmentQuery)
}

export function completeCurrentOrder() {
  return buildClient().query(completeCurrentOrderQuery)
}
